import React, { useState } from "react";

import { format, parse, isValid } from "date-fns";
import pt from "date-fns/locale/pt";

import DatePicker, { registerLocale } from "react-datepicker";
import { Box } from "@chakra-ui/react";

import CustomDatepickerInput from "../CustomDatepickerInput";

registerLocale("pt-br", pt);

export const CustomDatepicker = ({
  value,
  setValue,
  placeholder,
  isDisabled,
  maxDate,
  widthInput,
  clear,
  setIsFocused,
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  return (
    <Box
      w={widthInput || "auto"}
      sx={{
        ".react-datepicker-wrapper": { width: "100%" },
        ".react-datepicker__input-container": { width: "100%" },
      }}
    >
      <DatePicker
        selected={
          value?.length === 10 &&
          isValid(parse(value, "dd/MM/yyyy", new Date()))
            ? parse(value, "dd/MM/yyyy", new Date())
            : new Date()
        }
        onChange={(date) => {
          if (isValid(date)) {
            setValue(format(new Date(date), "dd/MM/yyyy"));
            setOpenCalendar(false);
            if (clear) {
              clear();
            }
          }
        }}
        dateFormat="dd/MM/yyyy"
        locale="pt-br"
        customInput={
          <CustomDatepickerInput
            customPlaceholder={placeholder}
            onIconClick={() => setOpenCalendar(true)}
            clear={clear}
            setFieldValue={setValue}
            fieldValue={value}
            disabled={!!isDisabled}
            widthInput={widthInput}
            setIsFocused={setIsFocused && setIsFocused}
          />
        }
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        open={openCalendar}
        onClickOutside={() => setOpenCalendar(false)}
        disabled={!!isDisabled}
        autoComplete="off"
        maxDate={maxDate}
      />
    </Box>
  );
};
